import { useDispatch } from "react-redux";
import type { AppDispatch } from "~/store/types.ts";

export default function useAppDispatch(): AppDispatch {
	return useDispatch();
}
